import { cn } from '@/lib/shadcn/utils';
import React, { type FC } from 'react';

const ExamplesHeader: FC<Readonly<React.HTMLAttributes<HTMLDivElement>>> = ({
  className,
  children,
  ...props
}) => {
  return (
    <section
      className={cn('overflow-hidden bg-[#0A0A0A] pt-16 sm:pt-16', className)}
      {...props}
    >
      <div className="container px-6 sm:pt-8 lg:px-8">{children}</div>
    </section>
  );
};

const Examples: FC<Readonly<React.HTMLAttributes<HTMLDivElement>>> = ({
  className,
  children,
  ...props
}) => {
  return (
    <div className={cn('pt-16 ml-0', className)} {...props}>
      {children}
    </div>
  );
};

const ExamplesRow: FC<Readonly<React.HTMLAttributes<HTMLDivElement>>> = ({
  className,
  children,
  ...props
}) => {
  return (
    <div className={cn('pb-24 text-center', className)} {...props}>
      <div className="mx-auto lg:max-w-lg">{children}</div>
    </div>
  );
};

const ExamplesHeading: FC<Readonly<React.HTMLAttributes<HTMLDivElement>>> = ({
  className,
  children,
  ...props
}) => {
  return (
    <h2
      className={cn(
        'mt-2 text-pretty text-4xl font-semibold tracking-tight text-white sm:text-5xl',
        className
      )}
      {...props}
    >
      {children}
    </h2>
  );
};

const ExamplesActions: FC<Readonly<React.HTMLAttributes<HTMLDivElement>>> = ({
  className,
  ...props
}) => {
  return <div className={cn('my-5', className)} {...props} />;
};

export {
  ExamplesActions,
  Examples,
  ExamplesHeading,
  ExamplesHeader,
  ExamplesRow,
};
